import { LazyLoadImage } from 'react-lazy-load-image-component';
import './LiveLikeALocalImage.scss';
import { useEffect, useState } from 'react';
import { LiveLikeALocalSidebarImageProps } from '../LiveLikeALocal.types';
import { sanityDataset, sanityImagesBaseUrl, sanityProjectId } from '../../../../sanity.io/config';
function LiveLikeALocalImage({ sidebarImageUrl, innerClass }: LiveLikeALocalSidebarImageProps) {
  const [img, setImg] = useState('');

  useEffect(() => {
    if (sidebarImageUrl) {
      setImg(sidebarImageUrl.split('image-')[1].replace('-jpg', '.jpg'));
    }
  }, [sidebarImageUrl]);
  return (
    <>
      <div className={`col-12 col-sm-4 my-4 sanity-sidebar-img-div ${innerClass}`}>
        <LazyLoadImage src={`${sanityImagesBaseUrl}/${sanityProjectId}/${sanityDataset}/${img}`} className="sanity-sidebar-image" />
      </div>
    </>
  );
}

export default LiveLikeALocalImage;
